var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-tooltip"},[_c('Popper',{attrs:{"placement":_vm.placement,"trigger":_vm.trigger},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},[_c('span',[_c('i',{class:`icon icon-${_vm.icon} icon-tooltip__icon`})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }